import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';

import { useTokenStore } from './TokenStore';

const Impersonate = () => {
  const [searchParams] = useSearchParams();
  const tokenStore = useTokenStore();

  useEffect(() => {
    const access_token = searchParams.get('access_token');
    const destination = searchParams.get('destination');
    tokenStore.storeToken(access_token, 'Homeroom');
    window.location.href = destination;
  }, [searchParams, tokenStore]);
};

export default Impersonate;
